var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88224 2.67423L1.07759 11.4875C1.03329 11.5319 1.00131 11.5881 0.986077 11.6484L0.0101651 15.5691C-0.0190272 15.6871 0.0156228 15.8126 0.101677 15.8988C0.166788 15.9639 0.255507 16 0.346257 16C0.374054 16 0.402484 15.9966 0.430154 15.9896L4.34725 15.0127C4.4083 14.9974 4.46377 14.9655 4.50806 14.9212L13.3135 6.10857L9.88224 2.67423Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4926 1.47248L14.5125 0.491494C13.8574 -0.164149 12.7157 -0.163514 12.0615 0.491494L10.8609 1.69315L14.292 5.12736L15.4926 3.92571C15.8198 3.59833 16 3.16259 16 2.69916C16 2.23572 15.8198 1.79998 15.4926 1.47248Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.dd4026d4bac66141b96759d49264eada.svg";
export { ForwardRef as ReactComponent };